export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 text-center mb-3">热门推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">编辑精选，本周最值得一看的好看漫画</p>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4" data-product-shop>
          {/* Card 1 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[3/4] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20cover%20style%2C%20solo%20leveling%20inspired%2C%20dark%20fantasy%20warrior%20with%20glowing%20eyes%2C%20dramatic%20lighting%2C%20cool%20tone%20with%20warm%20orange%20accents%2C%20clean%20composition&width=600&height=800&seq=card-01&orientation=portrait"
                alt="我独自升级"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2">
                <span className="bg-primary-500 text-background-50 text-[10px] px-1.5 py-0.5 rounded font-medium">韩漫</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-xs md:text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">我独自升级</h3>
              <p className="text-[10px] md:text-xs text-foreground-500 mt-0.5">热血 · 奇幻</p>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[3/4] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Japanese%20manga%20cover%20style%2C%20jujutsu%20kaisen%20inspired%2C%20dark%20sorcerer%20with%20mystical%20energy%2C%20dynamic%20action%20pose%2C%20deep%20shadows%20with%20crimson%20highlights&width=600&height=800&seq=card-02&orientation=portrait"
                alt="咒术回战"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2">
                <span className="bg-accent-500 text-background-50 text-[10px] px-1.5 py-0.5 rounded font-medium">日漫</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-xs md:text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">咒术回战</h3>
              <p className="text-[10px] md:text-xs text-foreground-500 mt-0.5">战斗 · 黑暗</p>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[3/4] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20manhua%20cover%20style%2C%20ancient%20Chinese%20deity%20in%20flowing%20robes%2C%20ethereal%20celestial%20atmosphere%2C%20ink%20wash%20influence%2C%20soft%20golden%20and%20crimson%20tones&width=600&height=800&seq=card-03&orientation=portrait"
                alt="天官赐福"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2">
                <span className="bg-secondary-500 text-background-50 text-[10px] px-1.5 py-0.5 rounded font-medium">国漫</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-xs md:text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">天官赐福</h3>
              <p className="text-[10px] md:text-xs text-foreground-500 mt-0.5">古风 · 仙侠</p>
            </div>
          </div>

          {/* Card 4 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[3/4] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20romance%20cover%20style%2C%20beautiful%20princess%20in%20elegant%20dress%2C%20royal%20palace%20setting%2C%20soft%20pink%20and%20gold%20color%20palette%2C%20fairy%20tale%20aesthetic&width=600&height=800&seq=card-04&orientation=portrait"
                alt="某天成为公主"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2">
                <span className="bg-primary-500 text-background-50 text-[10px] px-1.5 py-0.5 rounded font-medium">韩漫</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-xs md:text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">某天成为公主</h3>
              <p className="text-[10px] md:text-xs text-foreground-500 mt-0.5">恋爱 · 穿越</p>
            </div>
          </div>

          {/* Card 5 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[3/4] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20manhua%20historical%20cover%20style%2C%20fierce%20warrior%20in%20ancient%20armor%2C%20desert%20landscape%2C%20bold%20brushwork%20influence%2C%20earthy%20warm%20tones%20with%20dark%20silhouettes&width=600&height=800&seq=card-05&orientation=portrait"
                alt="镖人"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2">
                <span className="bg-secondary-500 text-background-50 text-[10px] px-1.5 py-0.5 rounded font-medium">国漫</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-xs md:text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">镖人</h3>
              <p className="text-[10px] md:text-xs text-foreground-500 mt-0.5">历史 · 武侠</p>
            </div>
          </div>

          {/* Card 6 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[3/4] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Japanese%20manga%20adventure%20cover%20style%2C%20pirate%20crew%20on%20ship%2C%20dynamic%20group%20pose%2C%20ocean%20background%20with%20dramatic%20sky%2C%20vibrant%20warm%20colors%2C%20classic%20shounen%20aesthetic&width=600&height=800&seq=card-06&orientation=portrait"
                alt="海贼王"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2">
                <span className="bg-accent-500 text-background-50 text-[10px] px-1.5 py-0.5 rounded font-medium">日漫</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-xs md:text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">海贼王</h3>
              <p className="text-[10px] md:text-xs text-foreground-500 mt-0.5">冒险 · 热血</p>
            </div>
          </div>

          {/* Card 7 */}
          <div className="bg-background-100 rounded-lg border border-background-200/70 overflow-hidden group cursor-pointer">
            <div className="relative w-full aspect-[3/4] bg-background-200 overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20mystery%20cover%20style%2C%20detective%20character%20in%20dark%20alley%2C%20noir%20atmosphere%2C%20neon%20signs%20reflection%2C%20suspenseful%20mood%2C%20cool%20tones%20with%20warm%20orange%20streetlight&width=600&height=800&seq=card-07&orientation=portrait"
                alt="追踪者"
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute top-2 left-2">
                <span className="bg-primary-500 text-background-50 text-[10px] px-1.5 py-0.5 rounded font-medium">韩漫</span>
              </div>
            </div>
            <div className="p-3">
              <h3 className="text-xs md:text-sm font-medium text-foreground-800 truncate group-hover:text-primary-500 transition-colors">追踪者</h3>
              <p className="text-[10px] md:text-xs text-foreground-500 mt-0.5">悬疑 · 推理</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-8">
          <a href="#index" className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 transition-colors cursor-pointer">
            查看更多漫画类型
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}